<template>
  <v-row no-gutters>
    <v-col cols="12">
      <h4 class="mb-3">{{ $t(title) }}</h4>
    </v-col>
    <!-- <v-col cols="12">
      <v-text-field
        name="searchTerm"
        prepend-inner-icon="icon-search"
        :label="this.$t('message.common.searchTerm')"
        id="id"
      >
      </v-text-field>
    </v-col> -->
    <v-col cols="12" class="fill-height">
      <div class="keyword-list__wrapper">
        <vue-perfect-scrollbar class="scroll-area" :settings="settings">
          <v-list
            class="scroll-y keyword-list"
            :min-height="minHeight"
            :max-height="maxHeight"
          >
            <template v-for="item in items">
              <v-list-item
                :key="item.id"
                ripple
                @click="emitSelected(item)"
                :class="selectedId === item.id ? '--active' : ''"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
                <!-- <v-menu left>
                  <template #activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon color="secondary">more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title>{{
                        $t("message.common.delete")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
              </v-list-item>
            </template>
          </v-list>
        </vue-perfect-scrollbar>
      </div>
    </v-col>
    <v-col cols="12" class="d-flex justify-center" v-if="hasAddButton">
      <ui-button
        icon="icon-plus"
        color="primary"
        class="mb-0 mt-3"
        @click="handleAddNewKeyWord"
      >
        {{ $t("message.common.addNewTerm") }}
      </ui-button>
    </v-col>
  </v-row>
</template>

<script>
import { gtmEvent__buttonClick } from "@/helpers/gtm-events";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "KeywordList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    minHeight: {
      type: Number,
      default: 468
    },
    maxHeight: {
      type: Number,
      default: 480
    },
    hasAddButton: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "message.common.searchTerms"
    },
    selectedId: {
      type: Number,
      required: true
    },
    selectedAdditionalItemId: {
      type: Number,
      required: 0
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    };
  },
  methods: {
    emitSelected(item) {
      if (this.selectedId === item.id) return;

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.KEYWORDS_LIST_SELECT,
        keyword_id: item.id,
        keyword_name: item.name
      });

      this.$emit("update:selectedId", item.id);
    },
    handleAddNewKeyWord() {
      gtmEvent__buttonClick({ label: "add_new_keyword" });

      this.$router.push(
        this.selectedAdditionalItemId
          ? {
              name: "profile-company-in-web",
              query: {
                itemId: this.selectedAdditionalItemId
              }
            }
          : {
              name: "profile-company-in-web"
            }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.keyword-list__wrapper {
  position: relative;
}

.scroll-area {
  border: 1px solid rgba($dark, 0.05);
  border-radius: 1px;
}

.--active {
  background-color: rgba($primary, 0.25);
}
</style>
